import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Grid, Paper, Tab } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { SnackbarAlertWidget } from '../../../../../widgets';
import EntHorBloquesView from '../../enthor_bloques/EntHorBloquesView';
import EntHorDiasView from '../../enthor_dias/EntHorDiasView';
import VistaPreviaEntHorarioClasesComponent from '../components/VistaPreviaEntHorarios';

const AjustesEntHorarioClasesView = () => {
  const entHorariosClasesStore = Redux.useSelector(
    (state) => state.entHorariosClases,
  );

  const [tab, setValue] = React.useState('1');

  const handleTabs = (_, newValue) => {
    setValue(newValue);
  };

  return (
    <Grid container spacing={1}>
      <SnackbarAlertWidget alert={entHorariosClasesStore.alertView} />
      <Grid item md={12}>
        <Paper elevation={4}>
          <TabContext value={tab}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabs} aria-label="lab API tabs example">
                <Tab label="Días de clases" value="1" />
                <Tab label="Bloques de horas" value="2" />
                <Tab label="Vista previa" value="3" />
              </TabList>
            </Box>
            <TabPanel value="1">
              <EntHorDiasView />
            </TabPanel>
            <TabPanel value="2">
              <EntHorBloquesView />
            </TabPanel>
            <TabPanel value="3">
              <VistaPreviaEntHorarioClasesComponent />
            </TabPanel>
          </TabContext>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default AjustesEntHorarioClasesView;
